if (!customElements.get('product-availability')) {
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const API = `${ROOT}api/2026-07/graphql.json`;
  const QUERY = `query($handle: String!) {
    product(handle: $handle) {
      variants(first: 100) {
        nodes { id storeAvailability(first: 10) { nodes { available pickUpTime location { id name } } } }
      }
    }
  }`;
  const cache = {};

  const numericId = (gid) => String(gid).split('/').pop();

  // { variante: [{ name, available, time }] }; null si la consulta falla
  const loadStores = (handle) => {
    if (!cache[handle]) {
      cache[handle] = fetch(API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query: QUERY, variables: { handle } }),
      })
        .then((res) => res.json())
        .then((json) => {
          const product = json.data && json.data.product;
          if (!product) return null;
          const byVariant = {};
          product.variants.nodes.forEach((v) => {
            byVariant[numericId(v.id)] = v.storeAvailability.nodes.map((s) => ({
              name: s.location.name,
              available: s.available,
              time: s.pickUpTime,
            }));
          });
          return byVariant;
        })
        .catch(() => null);
    }
    return cache[handle];
  };

  // "Usually ready in 4 hours" / "Normalmente está listo en 4 horas" -> "Listo en 4 horas"
  const pickupTime = (text) => {
    const match = /(\d+(?:\s*-\s*\d+|\+)?)\s*(minute|minuto|hour|hora|day|d[ií]a)s?/i.exec(text || '');
    if (!match) return '';
    const amount = match[1].replace(/\s+/g, '');
    const plural = !/^1$/.test(amount);
    const kind = match[2].toLowerCase();
    const unit = /^min/.test(kind) ? 'minuto' : /^(hour|hora)/.test(kind) ? 'hora' : 'día';
    return `Listo en ${amount} ${unit}${plural ? 's' : ''}`;
  };

  const stateFor = (variant, lowMax) => {
    if (variant.t <= 0) return variant.c ? ['is-ok', 'Disponible'] : ['is-none', 'No disponible'];
    if (variant.t <= lowMax) return ['is-low', 'Últimas unidades'];
    return ['is-ok', 'Disponible'];
  };

  const setState = (item, [cls, text]) => {
    item.classList.remove('is-ok', 'is-low', 'is-none', 'is-loading');
    item.classList.add(cls);
    item.querySelector('[data-pa-state]').textContent = text;
  };

  class ProductAvailability extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.data = JSON.parse(this.querySelector('[data-pa-data]').textContent);
      this.lowMax = parseInt(this.dataset.lowMax, 10) || 5;
      this.placeholder = this.querySelector('[data-pa-placeholder]');
      this.template = this.placeholder.cloneNode(true);
      this.target = document.getElementById(this.dataset.form) || document;
      this.onVariantChange = (event) => {
        const variant = event.detail && event.detail.variant;
        this.update(variant ? String(variant.id) : null);
      };
      this.target.addEventListener('variant:change', this.onVariantChange);
      this.update(this.dataset.variant);
    }

    disconnectedCallback() {
      if (this.target) this.target.removeEventListener('variant:change', this.onVariantChange);
    }

    clearStores() {
      this.querySelectorAll('[data-pa-store]').forEach((item) => item.remove());
      if (this.placeholder) this.placeholder.remove();
      this.placeholder = null;
    }

    update(variantId) {
      this.current = variantId;
      const variant = variantId && this.data[variantId];
      this.hidden = !variant || !variant.tr;
      if (this.hidden) return;

      setState(this.querySelector('[data-pa-online]'), stateFor(variant, this.lowMax));

      this.clearStores();
      this.placeholder = this.template.cloneNode(true);
      this.querySelector('.pa__list').appendChild(this.placeholder);

      loadStores(this.dataset.handle).then((byVariant) => {
        if (this.current !== variantId) return;
        const stores = byVariant && byVariant[variantId];
        this.clearStores();
        if (!stores) return;
        const list = this.querySelector('.pa__list');
        stores.forEach((store) => {
          const item = this.template.cloneNode(true);
          item.removeAttribute('data-pa-placeholder');
          item.setAttribute('data-pa-store', '');
          const text = item.querySelector('.pa__name').parentElement;
          item.querySelector('.pa__name').textContent = `Retiro en ${store.name}`;
          const time = store.available ? pickupTime(store.time) : '';
          if (time) {
            const meta = document.createElement('span');
            meta.className = 'pa__meta';
            meta.textContent = time;
            text.appendChild(meta);
          }
          const where = document.createElement('a');
          where.className = 'pa__meta pa__where';
          where.href = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent('Av. Las Condes 13451, Las Condes, Chile');
          where.target = '_blank';
          where.rel = 'noopener';
          where.textContent = 'Av. Las Condes 13451, Las Condes';
          text.appendChild(where);
          const hours = document.createElement('span');
          hours.className = 'pa__meta';
          hours.textContent = 'Lunes a domingo, 10:00 a 20:00 hrs';
          text.appendChild(hours);
          setState(item, store.available ? ['is-ok', 'Disponible'] : ['is-none', 'No disponible']);
          list.appendChild(item);
        });
      });
    }
  }

  customElements.define('product-availability', ProductAvailability);
}
